export default {
  backButton: 'Back to Calendar Items',
  removeSuccessMessage: 'Calendar Event Was Removed',
};
